import { schemaTranslations } from '@scalar/blocks/schema'
import type { ApiReferenceTranslations } from '@scalar/types/api-reference'

export const ru = {
  common: {
    streamItem: 'Элемент потока',
    description: 'Описание',
    httpMethod: 'HTTP-метод',
    path: 'Путь',
    copyDefault: 'Скопировать значение по умолчанию',
    copyExample: 'Скопировать пример значения',
  },
  search: {
    label: 'Поиск',
    inputLabel: 'Введите поисковый запрос',
    open: 'Открыть поиск',
    placeholder: 'Поиск...',
    clear: 'Очистить поиск',
    noResults: 'Результаты не найдены',
    keyboardShortcut: 'Сочетание клавиш:',
    command: 'Command',
    control: 'Control',
    results: 'Результаты поиска по документации',
    navigate: 'Навигация',
    select: 'Выбрать',
    instructions:
      'Нажмите стрелку вверх или вниз для навигации, Enter для выбора, вводите текст для фильтрации результатов',
    entryHeading: 'Заголовок',
    entryOperation: 'Операция',
    entryTag: 'Тег',
    entryTagGroup: 'Группа тегов',
    entryChannel: 'Канал',
    entryMessage: 'Сообщение',
    entryWebhook: 'Вебхук',
  },
  navigation: {
    introduction: 'Введение',
    closeGroup: 'Закрыть группу',
    closeMenu: 'Закрыть меню',
    openGroup: 'Открыть группу',
    openMenu: 'Открыть меню',
    operations: 'Операции',
    endpoints: 'Эндпоинты {name}',
    showAllEndpoints: 'Показать все эндпоинты {name}',
    sidebarFor: 'Боковая панель для {name}',
    mainContent: 'Документация API для {name}',
    collapsed: 'Свернуто',
    webhooks: 'Вебхуки',
    channels: 'Каналы',
  },
  server: {
    label: 'Сервер',
    select: 'Выберите сервер',
  },
  info: {
    termsOfService: 'Условия использования',
  },
  asyncapi: {
    address: 'Адрес',
    unknownAddress: 'Неизвестен',
    applicationIdentifier: 'Идентификатор приложения',
    servers: 'Серверы',
    protocols: 'Протоколы',
  },
  clientLibraries: {
    heading: 'Клиентские библиотеки',
    more: 'Ещё',
    selectAll: 'Выбрать из всех клиентов',
    searchLabel: 'Поиск клиентов',
    changeClient: 'Изменить язык примера кода',
  },
  operation: {
    codeSampleUnavailable: 'Для этого примера нет доступного образца кода.',
    codeSample: 'Пример кода',
    body: 'Тело',
    cookies: 'Cookie',
    headers: 'Заголовки',
    pathParameters: 'Параметры пути',
    queryParameters: 'Query-параметры',
    requestBody: 'Тело запроса',
    responses: 'Ответы',
    testRequest: 'Проверить запрос',
    webhook: 'Вебхук',
    audience: 'Аудитория',
    selectedContentType: 'Выбранный тип содержимого',
    callbacks: 'Обратные вызовы',
  },
  response: {
    xmlGenerationLimit:
      'Пример XML превышает ограничение генерации. Укажите сериализованный пример XML, чтобы отобразить содержимое полностью.',
    xmlGenerationFailed: 'Не удалось создать пример XML: {message}',
    exampleResponses: 'Примеры ответов',
    noBody: 'Нет тела',
    showSchema: 'Показать схему',
    status: 'Статус',
  },
  schema: schemaTranslations['ru'].schema,
  download: {
    openapi: 'Скачать OpenAPI-документ',
    asyncapi: 'Скачать AsyncAPI-документ',
    asFormat: '{label} в формате {format}',
  },
  models: {
    label: 'Модели',
  },
  actions: {
    copyAsMarkdown: 'Копировать как Markdown',
    copied: 'Скопировано',
    copyMarkdownFailed: 'Не удалось скопировать Markdown',

    copyLink: 'Скопировать ссылку',
    copyLinkTo: 'Скопировать ссылку на {name}',
    copyToClipboard: 'Скопировать ссылку в буфер обмена',
    copyEndpointUrl: 'Скопировать URL endpoint-а',
    showMore: 'Показать ещё',
  },
  agent: {
    askAi: 'Спросить AI',
    askAiAgent: 'Спросить AI-агента',
    close: 'Закрыть клиент',
  },
  mcp: {
    generate: 'Создать MCP',
    connect: 'Подключить MCP',
  },
  sdk: {
    generate: 'Создать SDK',
  },
  developerTools: {
    title: 'Инструменты разработчика',
    configure: 'Настроить',
    share: 'Поделиться',
    deploy: 'Опубликовать',
    scalarConfiguration: 'Конфигурация Scalar',
    theme: 'Тема',
    layout: 'Макет',
    layoutOptions: 'Параметры макета',
    intro:
      'Инструменты разработчика позволяют настроить внешний вид и поведение документации. Также можно поделиться документацией через Scalar Registry.',
    disableToolbarBefore: 'Чтобы отключить панель, установите',
    disableToolbarAfter: 'в конфигурации.',
    localhostOnly: 'Инструменты разработчика отображаются только при запуске на localhost.',
    layoutModern: 'Современный',
    layoutClassic: 'Классический',
    showSidebar: 'Показать боковую панель',
    defaultOpenFirstTag: 'Открывать первый тег по умолчанию',
    defaultOpenAllTags: 'Открывать все теги по умолчанию',
    expandAll: 'Развернуть все {label}',
    expandAllParameters: 'Развернуть все параметры',
    expandAllSchemaProperties: 'Развернуть все свойства схемы',
    hideModelNames: 'Скрыть имена моделей',
    orderRequiredPropertiesFirst: 'Обязательные свойства первыми',
    orderSchemaPropertiesBy: 'Порядок свойств схемы',
    alphabeticalOrder: 'По алфавиту',
    documentOrder: 'Порядок документа',
    expandAllResponses: 'Развернуть все ответы',
    hideClientButton: 'Скрыть кнопку клиента',
    hideDarkModeToggle: 'Скрыть переключатель тёмной темы',
    hideModels: 'Скрыть {label}',
    hideSearch: 'Скрыть поиск',
    showOperationId: 'Показать ID операции',
    hideTestRequestButton: 'Скрыть кнопку тестового запроса',
    scalarDocs: 'Scalar Docs',
    deployDescription:
      'Опубликуйте документацию на Scalar — современной платформе документации для вашего API и не только.',
    shareTitle: 'Поделиться API Reference',
    shareDescription:
      'Загрузите документ OpenAPI, чтобы поделиться API Reference с другими. Так же просто, как нажать кнопку.',
    uploadDocument: 'Загрузить документ',
    temporaryLinkExpiration: 'Документ будет автоматически удалён через 7 дней.',
    deployOnScalar: 'Опубликовать на Scalar',
    deployFree: 'Опубликуйте документацию бесплатно.',
    additionalFeaturesMightRequire: 'Для дополнительных возможностей может потребоваться',
    generate: 'Создать',
    passwordProtection: 'Защита паролем',
    customDomains: 'Пользовательские домены',
    freeFormContent: 'Произвольный контент',
    cdnInfrastructure: 'CDN-инфраструктура',
    pullFromGitHub: 'Загрузка из GitHub',
    markdownMdx: 'Markdown/MDX',
    spectralLinting: 'Линтинг Spectral',
    jsonSchemaHosting: 'Хостинг JSON Schema',
    askAi: 'Спросить AI',
    mcpServers: 'MCP-серверы',
    unableToExportDocument: 'Не удалось экспортировать активный документ',
    unknownError: 'Произошла неизвестная ошибка',
    waitlistEmail: 'Электронная почта',
    waitlistPlaceholder: 'you@example.com',
    joinWaitlist: 'Встать в лист ожидания',
    waitlistSuccess: 'Спасибо! Мы свяжемся с вами!',
    waitlistError: 'Ой! Что-то пошло не так, попробуйте ещё раз',
    waitlistRateLimit: 'Слишком много регистраций, попробуйте ещё раз чуть позже',
    waitlistBack: 'Назад',
    deployApiButton: 'Развернуть API',
    deployFrameworkButton: 'Развернуть {framework}',
    deployApiTitle: 'Разверните свой API в Scalar',
    deployFrameworkTitle: 'Разверните своё приложение на {framework} в Scalar',
    deployApiDescription: 'Запускайте его в Scalar. 5 $ бесплатных кредитов, без карты.',
    hostingScaleTitle: 'Масштабируется вместе с трафиком',
    hostingScaleDescription: 'От 1 vCPU · 0,5 ГБ до 48 vCPU · 48 ГБ.',
    hostingIdleTitle: 'Засыпает без нагрузки, 0 $',
    hostingIdleDescription: 'Посекундная оплата за то, что работает. Без платы за запросы.',
    hostingDeploysTitle: 'Деплой при каждом push',
    hostingDeploysDescription: 'Превью для pull request, логи и метрики и приватная сеть к другим вашим сервисам.',
    hostingPlans: 'Далее 1 $/мес. на Free · Hobby 5 $/мес. с 5 $ использования · Pro 20 $/мес.',
    hostingSeePlans: 'Тарифы',
  },
  exploreScalar: {
    cta: 'Создать SDK и MCP',
    headline: 'Мгновенно создавайте SDK, MCP и документацию для вашего API',
    title: 'Всё, что нужно вашему API, из одного документа OpenAPI',
    generateTitle: 'SDK и MCP-серверы',
    generateDescription:
      'Типизированные клиентские библиотеки и MCP-сервер, созданные из этого документа и всегда актуальные.',
    platformTitle: 'Документация, порталы для разработчиков и реестр',
    platformDescription:
      'Публикуйте этот справочник с руководствами, размещайте API в реестре и тестируйте их в API-клиенте.',
    signUp: 'Попробовать бесплатно',
    bookDemo: 'Записаться на демо с Marc, нашим CEO',
    getDemo: 'или записаться на демо с Marc',
    messageMarc: 'Написать Marc в X',
    dmMarc: 'или просто напишите мне в X!',
    close: 'Закрыть',
    opensInNewTab: 'Откроется в новой вкладке',
    popupBlocked: 'Браузер заблокировал новую вкладку. Нажмите кнопку ещё раз, чтобы открыть её.',
    back: 'Назад',
    openBookingPage: 'Открыть страницу бронирования',
  },
  gettingStarted: {
    swaggerEditor: 'Swagger Editor',
    description:
      'Добро пожаловать в Scalar API References + Swagger Editor — бесплатный инструмент с открытым исходным кодом, который принимает файл Swagger/OAS и создаёт красивые API Reference.',
    showExample: 'Показать пример',
    uploadFile: 'Загрузить файл',
    integrations: 'ИНТЕГРАЦИИ',
    theming: 'ТЕМЫ',
    features: 'Возможности',
    customize: 'Настройка',
    customizeDescription: 'Используйте свою типографику и цветовые палитры или наши темы!',
    testing: 'Тестирование',
    testingDescription: 'Глубоко интегрированный REST API Client (тоже бесплатный и с открытым исходным кодом)',
    search: 'Поиск',
    searchDescription: 'Полностью интегрированный поиск (с использованием fuse.js)',
    hosting: 'Хостинг',
    hostingDescription: 'Бесплатный хостинг на поддомене https://apidocumentation.com',
    openApiSwagger: 'OpenAPI и Swagger',
    openApiSwaggerDescription: 'Поддержка OpenAPI 3.1, OpenAPI 3.0 и Swagger 2.0',
    codeSamples: 'Примеры кода',
    codeSamplesDescription: 'Примеры кода для демонстрации вашего API на самых популярных языках',
  },
  footer: {
    poweredByScalar: 'Работает на Scalar',
  },
  authentication: {
    detailsRequired: 'Требуется аутентификация',
    detailsOptional: 'Аутентификация необязательна',
    apiKey: 'Ключ API',
    mutualTLS: 'Взаимная аутентификация TLS',
    apiKeyCookie: 'Передайте ключ API в cookie «{name}».',
    apiKeyHeader: 'Передайте ключ API в заголовке «{name}».',
    apiKeyQuery: 'Передайте ключ API в параметре запроса «{name}».',
    title: 'Аутентификация',
    accepts: 'Принимает',
    allOf: 'все из:',
    authentication: 'аутентификация',
    optional: 'Аутентификация необязательна',
    oneOf: 'одно из:',
    required: 'Требуется аутентификация',
    requires: 'Требуется',
    scopes: 'Области OAuth',
  },
} satisfies ApiReferenceTranslations
